// src/components/icons/HomeIcon.js
import React from 'react';

/**
 * HomeIcon — SVG back/home button icon.
 * Uses fill="currentColor" so it inherits the parent element's CSS `color`
 * property, making it fully themeable via --color-buttons.
 */
const HomeIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    fill="currentColor"
    className={className}
  >
    {/* Roof left stroke */}
    <path d="M5,55 L50,8 L95,55 L85,55 L85,92 Q85,95 82,95 L63,95 L63,68 Q63,65 60,65 L40,65 Q37,65 37,68 L37,95 L18,95 Q15,95 15,92 L15,55 Z" />
    {/* Chimney */}
    <rect x="66" y="18" width="14" height="22" rx="2" />
  </svg>
);

export default HomeIcon;
